var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.239 17.1052L16.5671 17.4825L16.239 17.1052ZM2.25 10.5C2.25 5.94365 5.94365 2.25 10.5 2.25V1.25C5.39137 1.25 1.25 5.39137 1.25 10.5H2.25ZM10.5 2.25C15.0563 2.25 18.75 5.94365 18.75 10.5H19.75C19.75 5.39137 15.6086 1.25 10.5 1.25V2.25ZM10.5 13.625C12.9128 13.625 14.9721 15.1444 15.7706 17.2803L16.7073 16.9301C15.7674 14.4162 13.3435 12.625 10.5 12.625V13.625ZM18.75 10.5C18.75 12.9859 17.6511 15.2146 15.9109 16.7279L16.5671 17.4825C18.5164 15.7874 19.75 13.2875 19.75 10.5H18.75ZM15.9109 16.7279C14.4621 17.9878 12.5707 18.75 10.5 18.75V19.75C12.8209 19.75 14.9433 18.8946 16.5671 17.4825L15.9109 16.7279ZM5.22936 17.2803C6.02794 15.1444 8.08716 13.625 10.5 13.625V12.625C7.6565 12.625 5.23261 14.4162 4.29268 16.9301L5.22936 17.2803ZM10.5 18.75C8.42931 18.75 6.5379 17.9878 5.08912 16.7279L4.43292 17.4825C6.05674 18.8946 8.1791 19.75 10.5 19.75V18.75ZM5.08912 16.7279C3.34889 15.2146 2.25 12.9859 2.25 10.5H1.25C1.25 13.2875 2.48359 15.7874 4.43292 17.4825L5.08912 16.7279Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.625,
    transform: "matrix(1 0 0 -1 10.5 7.875)",
    stroke: "#333333",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/userCircle.f99f9fb6280807f1a42dd3b25695164e.svg";
export { ForwardRef as ReactComponent };